import { Fragment, useEffect, useState } from "react";

import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  hideLoader,
  saveSchemeDetails,
  showLoader,
} from "../../../../store/actions";
import {
  getPfmNames,
  getRegdSchemes,
  getSchemeDetails,
} from "../../../../store/actions/newSubscriber";
import CardComponent from "../../transactions/newInvestor/lib/CardComponent";
import { useNewSubscriberContext } from "../Context/NewSubsciberContext";
import {
  setSchemeDetails as setSchemeDetailsContext,
  setStatusBackToSummary,
} from "../Context/NewSubscriberAction";
import { Field, Form, Formik, getIn, useFormikContext } from "formik";
import * as Yup from "yup";
import FormTextInput from "./lib/formik/InputField";
import { DateField } from "./lib/formik/DateField";
import { useRef } from "react";
import FormRadioGroup from "./lib/formik/RadioGroup";
import { PieChartRadioGroup } from "./lib/formik/PieChartContainer";
import FormSelectInput from "./lib/formik/inputSelectField";
import {
  FREQUENCY,
  INVESTMENT_OPTIONS,
  PENSION_FUND_OPTIONS,
  SUCCESS_RESPONSE_CODE,
} from ".";
import FormSliderInput from "./lib/formik/SliderInputField";

const LIFECYCLE_PERCENTAGE_ALLOCATION = {
  2: [
    {
      SchemeCode: "",
      AssetCategory: "E",
      MinValue: 0,
      MaxValue: 50,
    },
    {
      SchemeCode: "",
      AssetCategory: "C",
      MinValue: 0,
      MaxValue: 30,
    },
    {
      SchemeCode: "",
      AssetCategory: "G",
      MinValue: 0,
      MaxValue: 20,
    },
  ],
  3: [
    {
      AssetCategory: "E",
      MinValue: 0,
      MaxValue: 25,
    },
    {
      AssetCategory: "C",
      MinValue: 0,
      MaxValue: 45,
    },
    {
      AssetCategory: "G",
      MinValue: 0,
      MaxValue: 30,
    },
  ],
  4: [
    {
      SchemeCode: "",
      AssetCategory: "E",
      MinValue: 0,
      MaxValue: 75,
    },
    {
      SchemeCode: "",
      AssetCategory: "C",
      MinValue: 0,
      MaxValue: 10,
    },
    {
      SchemeCode: "",
      AssetCategory: "G",
      MinValue: 0,
      MaxValue: 15,
    },
  ],
};

const LIFECYCLE_MAP = {
  2: "LC50",
  3: "LC25",
  4: "LC75",
};

const LABELS = {
  E: "Equity",
  C: "Corporate Bonds",
  G: "Government Securities",
  A: "Alternate Investment Funds",
};

const SchemeSection = ({ name, values }) => {
  const dispatch = useDispatch();
  const { ackNumber, schemeDetails: SD } = useNewSubscriberContext();
  const { setFieldValue } = useFormikContext();

  const schemePercentageDetails = values["schemePercentageDetails"] || [];

  const [pfmOptions, setpfmOptions] = useState([]);

  useEffect(() => {
    async function fetchPfmNames() {
      const response = await dispatch(getPfmNames());

      setpfmOptions(
        response?.data.map((option) => ({
          value: option.Id,
          label: option.Name,
        }))
      );
    }
    fetchPfmNames();
  }, []);

  useEffect(() => {
    async function fetchSchemePercentages(ioption) {
      try {
        dispatch(showLoader());
        const params = {
          ApplicantType: "AL",
          ackNumber,
          ioption: values["invOption"],
          pfund: values["pensionFundManager"],
          accountType: name === "tier1" ? "1" : "2",
        };

        const { data, statusCode, message } = await dispatch(
          getRegdSchemes(params)
        );

        if (+statusCode !== SUCCESS_RESPONSE_CODE)
          throw new Error(message || "Something went wrong");

        const percentages = data.map((item) => ({
          SchemeCode: item.SchemeCode,
          AssetCategory: item.AssetCategory,
          MinValue: item.MinValue,
          MaxValue: item.MaxValue,
          Percentage: SD?.data
            ? SD?.data[`${item.AssetCategory}${name === "tier1" ? "" : "2"}`] ||
              0
            : ioption !== "1"
            ? item.MaxValue
            : item.MinValue,
          // Percentage: ioption !== "1" ? item.MaxValue : item.MinValue,
        }));
        setFieldValue(`${name}.schemePercentageDetails`, percentages);
      } catch (error) {
        alert(error);
        console.error(error);
      } finally {
        dispatch(hideLoader());
      }
    }
    if (values["pensionFundManager"]) {
      if (values["invOption"] === "1") {
        fetchSchemePercentages("1");
      } else {
        fetchSchemePercentages(values["lifeCycleOption"]);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    values["pensionFundManager"],
    values["invOption"],
    values["lifeCycleOption"],
  ]);

  return (
    <Field name={name}>
      {({ field: { name: fieldName }, meta: { error } }) => {
        const { ITType, invOption } = values;
        const isOneTimeInvestment = +ITType === 1;
        const isOneTimeInvestmentSIP = +ITType === 3;
        const isActiveInvOption = +invOption === 1;
        const isAutoInvOption = +invOption === 2;
        const total = schemePercentageDetails.reduce(
          (acc, item) => acc + +item.Percentage,
          0
        );
        const schemePercentageErrors = getIn(error, `schemePercentageDetails`);
        const errorMessage =
          total > 0 && typeof schemePercentageErrors === "string"
            ? schemePercentageErrors
            : null;
        return (
          <CardComponent title="SCHEME DETAILS">
            <div
              style={{
                margin: "30px 0px 0px 30px",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              {name === "tier1" ? "Tier I" : "Tier II"}
            </div>
            <div>
              <FormRadioGroup
                name={`${fieldName}.ITType`}
                options={[{ label: "One Time Investment", value: "1" }]}
              />
            </div>
            <div className="new-investor-container">
              <FormTextInput
                label="Contribution Amount"
                name={`${fieldName}.contributionAmount`}
                type="number"
                placeholder={`Minimum Amount ₹.${
                  name === "tier1" ? 500 : 1000
                }`}
                required
              />
              <FormSelectInput
                label="Pension Funds"
                name={`${fieldName}.pensionFundManager`}
                options={pfmOptions || PENSION_FUND_OPTIONS}
                required
              />
              {isOneTimeInvestmentSIP && (
                <>
                  <FormSelectInput
                    label="Frequency"
                    name={`${fieldName}.frequency`}
                    options={FREQUENCY}
                    required
                  />
                  <DateField
                    label="Start Date"
                    name={`${fieldName}.startDate`}
                    required
                  />
                  <DateField
                    label="End Date"
                    name={`${fieldName}.endDate`}
                    required
                  />
                </>
              )}
              {isOneTimeInvestment && (
                <FormRadioGroup
                  label="Investment Options"
                  name={`${fieldName}.invOption`}
                  options={INVESTMENT_OPTIONS}
                  required
                />
              )}
            </div>
            {isAutoInvOption && (
              <PieChartRadioGroup
                label="Type of LifeCycle Fund"
                name={`${fieldName}.lifeCycleOption`}
                lifecycleOptions={LIFECYCLE_PERCENTAGE_ALLOCATION}
              />
            )}
            {isActiveInvOption && (
              <>
                <p
                  style={{
                    fontSize: "14px",
                    color: "#002856",
                    fontFamily: `'Roboto', sans-serif`,
                    marginLeft: "20px",
                  }}
                >
                  Percentage Allocation
                </p>
                <div
                  className="new-investor-container"
                  style={{ marginLeft: "16px" }}
                >
                  {schemePercentageDetails.map((item, i) => {
                    const { AssetCategory, MinValue, MaxValue } = item;
                    return (
                      <div>
                        <FormSliderInput
                          label={LABELS[AssetCategory]}
                          name={`${fieldName}.schemePercentageDetails.${i}.Percentage`}
                          minValue={MinValue}
                          maxValue={MaxValue}
                        />
                      </div>
                    );
                  })}
                  {errorMessage && (
                    <div className="nps-error-message">{errorMessage}</div>
                  )}
                </div>
              </>
            )}
          </CardComponent>
        );
      }}
    </Field>
  );
};

const SchemeDetails = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const {
    ackNumber,
    schemeDetails: SD,
    accountType: AT,
    dispatch: dispatchContext,
    isBackToSummary,
    oldAccountType,
  } = useNewSubscriberContext();

  const [accountType] = useState(AT?.data?.AccountType || "1");
  const hasTierTwo = accountType === "2";

  const goBack = () => {
    history.push({
      pathname: "/nps/AddSubs/investment-details",
    });
  };

  const {
    contribution_amount,
    contribution_amountT2,
    TierTwoInvestmentChoice,
    TierOneInvestmentChoice,
  } = SD?.data || {};

  const initialValues = {
    tier1: {
      ITType: "1",
      contributionAmount: contribution_amount || "",
      pensionFundManager: SD?.data?.TierOneFundCodeOpted || "",
      frequency: "",
      startDate: "",
      endDate: "",
      invOption: TierOneInvestmentChoice === 1 ? "1" : "2",
      lifeCycleOption:
        Object.keys(LIFECYCLE_MAP).find(
          (key) => LIFECYCLE_MAP[key] === SD?.data?.Lifecyclefundtierone
        ) || "",
      schemePercentageDetails: [],
    },
    ...(hasTierTwo
      ? {
          tier2: {
            ITType: "1",
            contributionAmount: !!contribution_amountT2
              ? contribution_amountT2
              : "",
            pensionFundManager: SD?.data?.TierTwoFundCodeOpted || "",
            frequency: "",
            startDate: "",
            endDate: "",
            invOption: TierTwoInvestmentChoice === 1 ? "1" : "2",
            lifeCycleOption:
              Object.keys(LIFECYCLE_MAP).find(
                (key) => LIFECYCLE_MAP[key] === SD?.data?.Lifecyclefundtiertwo
              ) || "",
            schemePercentageDetails: [],
          },
        }
      : {}),
  };

  const commonValidationSchema = Yup.object().shape({
    contributionAmount: Yup.number()
      .required("Contribution Amount is required")
      .min(500, "Contribution amount should be greater than 500."),
    pensionFundManager: Yup.string().required(
      "Pension Fund Manager is required"
    ),
    invOption: Yup.string()
      .oneOf(["1", "2"], "Investment Options is required")
      .required("Investment Options is required"),
    lifeCycleOption: Yup.string().when("invOption", (invOption, schema) => {
      return +invOption === 2
        ? schema.required("Life Cycle Option is required")
        : schema;
    }),
    schemePercentageDetails: Yup.array()
      .when("invOption", (invOption, schema) => {
        return +invOption === 1
          ? schema
              .of(
                Yup.object().shape({
                  Percentage: Yup.number()
                    .required("Percentage is required")
                    .min(0, "Percentage should be greater than 0")
                    .max(
                      Yup.ref("MaxValue"),
                      ({ max }) => `Percentage should be less than ${max}`
                    ),
                })
              )
              .min(1, "Atleast one scheme is required")
          : schema;
      })
      .test(
        "sum",
        "Sum of percentages should be 100",
        function (value, { parent: { invOption } }) {
          if (+invOption !== 1) {
            return true;
          }
          if (value) {
            const sum = value.reduce((acc, curr) => acc + curr.Percentage, 0);
            if (sum !== 100) {
              return this.createError({
                message: `Sum of percentages should be 100, Currently ${sum}`,
              });
            }
            return true;
          }
          return true;
        }
      ),
  });

  const validationSchema = Yup.object().shape({
    tier1: commonValidationSchema,
    ...(hasTierTwo
      ? {
          tier2: commonValidationSchema.clone().shape({
            contributionAmount: Yup.number()
              .required("Contribution amount is required")
              .min(
                1000,
                "Contribution amount for Tier II should be greater than 1000"
              ),
          }),
        }
      : {}),
  });

  const ref = useRef();

  const _handleSubmit = async (values) => {
    try {
      dispatch(showLoader());
      const params = {
        AccountType: accountType,
        AckNumber: ackNumber,
        TierOneFundCodeOpted: values.tier1.pensionFundManager,
        TierOneInvestmentChoice:
          values.tier1.invOption === "1" ? "1" : values.tier1.lifeCycleOption,
        contribution_amount: Number(values.tier1.contributionAmount),
        chkschemeSameasTier1: "N",
        Scheme: JSON.stringify(
          values["tier1"].schemePercentageDetails || []
        ).trim(),
        Scheme2: "[]",
        Lifecyclefundtierone:
          values.tier1.invOption === "1"
            ? ""
            : LIFECYCLE_MAP[values.tier1.lifeCycleOption],
        ...(hasTierTwo
          ? {
              TierTwoFundCodeOpted: values.tier2.pensionFundManager,
              TierTwoInvestmentChoice:
                values.tier2.invOption === "1"
                  ? "1"
                  : values.tier2.lifeCycleOption,
              contribution_amountT2: Number(values.tier2.contributionAmount),
              Lifecyclefundtiertwo:
                values.tier2.invOption === "1"
                  ? ""
                  : LIFECYCLE_MAP[values.tier2.lifeCycleOption],
              Scheme2: JSON.stringify(
                values["tier2"].schemePercentageDetails || []
              ).trim(),
            }
          : {}),
      };

      const response = await dispatch(saveSchemeDetails(params));

      if (Number(response.statusCode) !== SUCCESS_RESPONSE_CODE) {
        throw new Error(response.message || "Error saving scheme details");
      }

      const responseScheme = await dispatch(
        getSchemeDetails({ AckNumber: ackNumber })
      );

      dispatchContext(setSchemeDetailsContext(responseScheme));

      const backToSummary = [
        oldAccountType,
        isBackToSummary,
        oldAccountType === accountType,
      ].every(Boolean);

      if (backToSummary) {
        dispatchContext(setStatusBackToSummary(false));
        history.push("/nps/AddSubs/subscriber-summary");
        return;
      }

      history.push("/nps/AddSubs/nominee-details");
    } catch (error) {
      alert(error.message || error);
    } finally {
      dispatch(hideLoader());
    }
  };

  return (
    <Fragment>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        innerRef={ref}
        onSubmit={_handleSubmit}
      >
        {({ values, errors }) => {
          return (
            <Form>
              {Object.keys(values).map((key) => (
                <SchemeSection name={key} key={key} values={values[key]} />
              ))}
              <div className="d-flex justify-content-center">
                <button
                  className="new-investor-button"
                  onClick={goBack}
                  disabled={!goBack}
                  style={{
                    border: "1px solid #007ac8",
                    color: "#007ac8",
                  }}
                >
                  Back
                </button>
                <button
                  type="submit"
                  className="new-investor-button new-investor-active"
                >
                  Proceed
                </button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Fragment>
  );
};

export default SchemeDetails;
